import React, { useState, useEffect } from "react";
/*import HeliosLogo from "../../assets/Genie.svg";*/
import { ReactComponent as HeliosLogo } from "../../assets/Genielytics.svg";

import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/Button.tsx";
import { Input } from "../ui/Input.tsx";
import { Label } from "../ui/Label.tsx";
import "./Login.css";
import { Eye, EyeOff } from "lucide-react";
import { resetAppStorageForLogin } from "../../utils/scopedStorage";



const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
/*
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) navigate("/chatwindow");
  }, [navigate]);
*/


//for temprary later  will update 

useEffect(() => {
  // Let ProtectedRoute handle redirects
}, []);

useEffect(() => {
  const notice = sessionStorage.getItem("post_login_notice");
  if (notice) {
    setError(notice);
    sessionStorage.removeItem("post_login_notice");
  }
}, []);



  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);



const handleLogin = async (e) => {
  
  e.preventDefault();
resetAppStorageForLogin();

  if (isSubmitting) return;

  setError("");
  setValidationErrors({});
  setIsSubmitting(true);

  const errors = {};
  if (!email.trim()) errors.email = "Please fill in this field";
  else if (!validateEmail(email)) errors.email = "Invalid email";

  if (!password.trim()) errors.password = "Please fill in this field";
  else if (password.length < 8)
    errors.password = "Password must be at least 8 characters";

  if (Object.keys(errors).length > 0) {
    setValidationErrors(errors);
    setIsSubmitting(false);
    return;
  }

  try {
       const response = await axios.post("/auth/login", {
      email,
      password,
    });

    const { access_token, refresh_token, role, user } = response.data;
    const platformRole = user?.platform_role || (role === "super_admin" ? role : "");

    localStorage.setItem("access_token", access_token);
    localStorage.setItem("refresh_token", refresh_token);

    toast.success("Login successful!");
    navigate(platformRole ? "/platform" : "/chatwindow", { replace: true });
  } catch (error) {
if (!error.response) {
  setError("Server unreachable. Please try again.");
} else {
  setError(error.response.data?.msg || "Login failed");
}
  } finally {
    setIsSubmitting(false);
  }
};



  const handleInputChange = (field) => (e) => {
    setError("");
    setValidationErrors((prev) => ({ ...prev, [field]: "" }));

    if (field === "email") setEmail(e.target.value);
    if (field === "password") setPassword(e.target.value);
  };

return (
  <div className="min-h-screen flex items-center justify-center bg-background relative overflow-hidden">

    {/* Soft animated background glow */}
    <div className="absolute inset-0 bg-gradient-to-br from-[rgba(33,163,243,0.12)] via-transparent to-[rgba(168,118,223,0.12)] blur-3xl"></div>

<div className="relative w-full max-w-md p-6 sm:p-8 md:p-9 rounded-3xl border border-border bg-card/90 shadow-[0_30px_80px_rgba(99,102,241,0.25)] backdrop-blur-xl
">

      {/* Logo */}
      <div className="flex justify-center mb-8">
       {/* <img
          src={HeliosLogo}
          
          alt="Geneilytics"
          className="w-20 h-20 object-contain drop-shadow-lg"
        />*/}
        <div className="helios-logo-wrap">

        <HeliosLogo className="helios-logo" />

      </div>
      </div>

      {/* Title */}
      <h2 className="text-xl font-bold text-center text-foreground">
        Welcome to{" "}
        <span className="bg-gradient-to-r from-[#21A3F3] via-[#6366F1] to-[#A876DF] bg-clip-text text-transparent">
          Geneilytics
        </span>
      </h2>

      <p className="text-center text-sm text-muted-foreground mt-2">
        Sign in to access your AI workspace
      </p>

      <form onSubmit={handleLogin} className="mt-8 space-y-5" noValidate>

        {/* Email */}
        <div>
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            placeholder="you@company.com"
            value={email}
            onChange={handleInputChange("email")}
            error={!!validationErrors.email}
          />
          {validationErrors.email && (
            <p className="text-destructive text-xs mt-1 font-semibold">
              {validationErrors.email}
            </p>
          )}
        </div>

        {/* Password */}
        <div className="relative">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type={showPassword ? "text" : "password"}
            autoComplete="current-password"
            placeholder="••••••••"
            value={password}
            onChange={handleInputChange("password")}
            error={!!validationErrors.password}
          />

         <button
  type="button"
  onClick={togglePasswordVisibility}
  aria-label={showPassword ? "Hide password" : "Show password"}
  aria-pressed={showPassword}
  className="absolute right-3 top-[38px] text-muted-foreground hover:text-primary transition focus:outline-none focus:ring-2 focus:ring-primary rounded"
>
  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
</button>


          {validationErrors.password && (
            <p className="text-destructive text-xs mt-1 font-semibold">
              {validationErrors.password}
            </p>
          )}
        </div>

        {/* Error */}
        {error && (
          <p className="text-destructive text-sm font-semibold bg-destructive/10 border border-destructive rounded-md px-3 py-2">
            {error}
          </p>
        )}

        {/* Login Button */}
        <div>
          <Button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-gradient-to-r from-[#21A3F3] via-[#6366F1] to-[#A876DF] text-white shadow-lg hover:shadow-xl transition disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isSubmitting ? "Signing in..." : "Login"}
          </Button>

        </div>
      </form>

      {/* Footer */}
      <div className="mt-6 text-xs text-center text-muted-foreground">
        © 2026 ScatterPie Analytics Pvt. Ltd.
      </div>
    </div>
  </div>
);
}

export default Login;
